import { createSlice } from '@reduxjs/toolkit'

// Define initialState separately
const initialState = {
  uploadedImage: null,
  uploadedImageFile: null,
  uploadedAudio: null,
  uploadedAudioFile: null,
  hintDescription: ''
}

const talkingAvatarSlice = createSlice({
  name: 'talkingAvatar',
  initialState, 
  reducers: {
    updateTalkingAvatarData: (state, action) => {
      Object.assign(state, action.payload)
    },
    resetAvatarTalkingData: () => initialState 
  }
})

export const { updateTalkingAvatarData, resetAvatarTalkingData } =
  talkingAvatarSlice.actions

export default talkingAvatarSlice.reducer
